<grid [dao]="dao" [title]="isModal ? '' : title" [orderBy]="orderBy" [groupBy]="groupBy" [join]="join" [selectable]="selectable" (select)="onSelect($event)" >
  <filter [deleted]="this.auth.hasPermissionTo('MOD_AUDIT_DEL')" [form]="filter" [where]="filterWhere" [submit]="filterSubmit.bind(this)" [collapseChange]="filterCollapseChange.bind(this)" [collapsed]="!selectable && filterCollapsed">
    <div class="row">
        <input-text [size]="12" [label]="lex.translate('id')" controlName="plano_entrega_id" [attr.maxlength]=250
            [control]="filter!.controls.plano_entrega_id" ></input-text>
    </div>
  </filter>
  <columns>
    <column title="Data" [template]="columnData">
      <ng-template let-row="row" #columnData>
          <span> {{dao!.getDateFormatted(row.created_at)}}</span>
      </ng-template>
    </column>
    <column title="Status lançado" [template]="columnCodigo">
      <ng-template let-row="row" #columnCodigo>
          <span> {{row.codigo == "ATIVO" ? 'Em execução' : row.codigo == "AVALIADO" ? "Avaliado" : row.codigo == "CANCELADO" ? "Cancelado" :
            row.codigo == "CONCLUIDO" ? "Concluido" : row.codigo == "HOMOLOGANDO" ? "Enviado para homologação" : row.codigo == "AGUARDANDO_ASSINATURA" ? "Aguardando Assinatura" : 
            row.codigo == "INCLUIDO" ? "Incluído" : row.codigo == "INICIADO" ? "Vigente" : row.codigo == "EM_RECURSO" ? "Recorrido" :
            row.codigo == "SUSPENSO" ? "Suspenso" : row.codigo == "AGUARDANDO_CANCELAMENTO" ? "Aguardando o cancelamento" : "Sem descrição do motivo"}}</span>
      </ng-template>
    </column>
    <column title="Justificativa" field="justificativa"></column>
    <column title="Usuário" [template]="columnUsuario">
      <ng-template let-row="row" #columnUsuario>
          <div class="card" style="border:none;display:flex;flex-direction:row;max-width:350px;height:auto;background: #F5F7FA;border: none;padding:8px;font-size:14px;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;">
            <profile-picture [url]="row.usuario?.url_foto" [hint]="row.usuario?.nome || 'Desconhecido'"></profile-picture>
            <div style="display:flex;flex-direction:column;border:none;">
              <h1 style="font-size:14px;font-weight:bold;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Oxygen-Sans,Ubuntu,Cantarell,Helvetica Neue,sans-serif;"> {{row.usuario?.nome || ""}}</h1>
              <span style="font-size:10px;font-weight:bold">{{row.usuario?.apelido}}</span>
              <span style="font-size:12px;">{{row.usuario?.email || ""}}</span>
            </div>
          </div>
      </ng-template>
    </column>
  </columns>
  <pagination [rows]="rowsLimit"></pagination>
</grid>